// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"370cafde","453":"abd36b29","455":"10ba8eec"}[chunkId] + ".chunk.js";
};